var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"fake"},[_c('div',{staticClass:"searchIcon"}),_c('div',{staticClass:"searchbar"},[_vm._v("请输入股票/行业/关键词/研究员")])])
}]

export { render, staticRenderFns }